import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import theme from './utils/theme';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import Startmessagemenu from './components/startchat';
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<Provider store={store}>
		<ThemeProvider theme={theme}>
			<Startmessagemenu />
			<App />
		</ThemeProvider>
	</Provider>
);
